import { render, staticRenderFns } from "./local-distribution.vue?vue&type=template&id=60f07b3f&"
import script from "./local-distribution.vue?vue&type=script&lang=js&"
export * from "./local-distribution.vue?vue&type=script&lang=js&"
import style0 from "./local-distribution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports